import { render, staticRenderFns } from "./city-rank.vue?vue&type=template&id=266c1536&scoped=true&"
import script from "./city-rank.vue?vue&type=script&lang=js&"
export * from "./city-rank.vue?vue&type=script&lang=js&"
import style0 from "./city-rank.vue?vue&type=style&index=0&id=266c1536&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266c1536",
  null
  
)

export default component.exports